// @ts-check
// Chamadas da lixeira (docs/arquitetura-appcrm/08-contrato-lixeira.md): excluir definitivamente em lote e o prazo
// da retenção automática. Restaurar em lote usa restoreManyRecords (data/parity.js).
import { signal } from '@preact/signals';
import { api } from './api-client.js';
import { BATCH_SIZE } from './parity.js';
import { mutationCounterState } from './record-store.js';

/**
 * @typedef {import('../lib/field-metadata.js').ObjectMetadata} ObjectMetadata
 * @typedef {import('./parity.js').BatchResult} BatchResult
 */

/** Prazo lido uma vez por sessão: a lixeira vazia avisa em quantos dias os itens somem. */
export const trashRetentionDaysState = signal(/** @type {number | null} */ (null));

/**
 * @param {ObjectMetadata} objectMetadata @param {string[]} ids
 * @returns {Promise<BatchResult>}
 */
export async function destroyManyRecords(objectMetadata, ids) {
  /** @type {BatchResult} */
  const result = { records: [], errors: [] };
  for (let start = 0; start < ids.length; start += BATCH_SIZE) {
    const body = await api.post(`/rest/${objectMetadata.namePlural}/batch-destroy`, { ids: ids.slice(start, start + BATCH_SIZE) });
    const partial = body?.data?.destroyRecords ?? { records: [], errors: [] };
    result.records.push(...partial.records);
    result.errors.push(...partial.errors);
  }
  mutationCounterState.value += 1;
  return result;
}

/** @returns {Promise<{ trashRetentionDays: number }>} */
export async function getTrashSettings() {
  const body = await api.get('/rest/trash/settings');
  const settings = body.data.trashSettings;
  trashRetentionDaysState.value = settings.trashRetentionDays;
  return settings;
}

/** @param {number} trashRetentionDays */
export async function updateTrashSettings(trashRetentionDays) {
  const body = await api.patch('/rest/trash/settings', { trashRetentionDays });
  const settings = body.data.updateTrashSettings;
  trashRetentionDaysState.value = settings.trashRetentionDays;
  return settings;
}

/** Carrega o prazo se ainda não foi lido; uma falha só deixa o aviso de fora. */
export function ensureTrashSettingsLoaded() {
  if (trashRetentionDaysState.value !== null) return;
  getTrashSettings().catch(() => {});
}
